import React from "react";
import Pictures from "../Pic";
import { Link } from "react-router-dom";
import "./FindUs.css";

function FindUs() {
  return (
    <>
      <section className="mii">
        <img src={Pictures.mii} alt="Make in India" />
      </section>
      <section className="findUs">
        <div className="findUsInnerSec dark_bg">
          <div className="mainHeading center">Find us</div>
          <div className="subHeading">Prabhakar (Director)</div>
          <p className="center">
            Creative Balloons Head Office,
            <br />
            Plot No: 5, Lakshminagar, Near Pillor No: 63, Mehdipatnam,
            Hyderabad-500081.
          </p>
          <div className="FindUsDetails disFlex">
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.77762 11.9424C2.8296 10.2893 2.37185 8.93948 2.09584 7.57121C1.68762 5.54758 2.62181 3.57081 4.16938 2.30947C4.82345 1.77638 5.57323 1.95852 5.96 2.6524L6.83318 4.21891C7.52529 5.46057 7.87134 6.08139 7.8027 6.73959C7.73407 7.39779 7.26737 7.93386 6.33397 9.00601L3.77762 11.9424ZM3.77762 11.9424C5.69651 15.2883 8.70784 18.3013 12.0576 20.2224M12.0576 20.2224C13.7107 21.1704 15.0605 21.6282 16.4288 21.9042C18.4524 22.3124 20.4292 21.3782 21.6905 19.8306C22.2236 19.1766 22.0415 18.4268 21.3476 18.04L19.7811 17.1668C18.5394 16.4747 17.9186 16.1287 17.2604 16.1973C16.6022 16.2659 16.0661 16.7326 14.994 17.666L12.0576 20.2224Z"
                  stroke="#141B34"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>

              <p>9000643036</p>
            </span>
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.91142 20.9796L9.96336 20.2314H9.96336L9.91142 20.9796ZM2.0204 13.0886L2.7686 13.0366L2.0204 13.0886ZM21.9796 13.0886L21.2314 13.0366V13.0366L21.9796 13.0886ZM14.0886 20.9796L14.0366 20.2314H14.0366L14.0886 20.9796ZM14.0886 2.5204L14.0366 3.2686L14.0886 2.5204ZM21.9796 10.4114L21.2314 10.4634V10.4634L21.9796 10.4114ZM9.91142 2.5204L9.96336 3.2686L9.91142 2.5204ZM2.0204 10.4114L2.7686 10.4634L2.0204 10.4114ZM3.62564 17.5L4.32168 17.7793L4.47628 17.3941L4.23193 17.0585L3.62564 17.5ZM2.0204 21.5L1.32436 21.2207C1.21546 21.492 1.27419 21.8019 1.47482 22.0146C1.67546 22.2273 1.98141 22.304 2.25865 22.2112L2.0204 21.5ZM6.49772 20L6.85114 19.3385L6.56601 19.1862L6.25947 19.2888L6.49772 20ZM11.25 3.25H12.75V1.75H11.25V3.25ZM12.75 20.25H11.25V21.75H12.75V20.25ZM11.25 20.25C10.541 20.25 10.2248 20.2495 9.96336 20.2314L9.85949 21.7278C10.1859 21.7505 10.5662 21.75 11.25 21.75V20.25ZM1.25 11.75C1.25 12.4338 1.24955 12.8141 1.2722 13.1405L2.7686 13.0366C2.75045 12.7752 2.75 12.459 2.75 11.75H1.25ZM21.25 11.75C21.25 12.459 21.2495 12.7752 21.2314 13.0366L22.7278 13.1405C22.7505 12.8141 22.75 12.4338 22.75 11.75H21.25ZM12.75 21.75C13.4338 21.75 13.8141 21.7505 14.1405 21.7278L14.0366 20.2314C13.7752 20.2495 13.459 20.25 12.75 20.25V21.75ZM21.2314 13.0366C20.9637 16.8939 17.8939 19.9637 14.0366 20.2314L14.1405 21.7278C18.7443 21.4082 22.4082 17.7443 22.7278 13.1405L21.2314 13.0366ZM12.75 3.25C13.459 3.25 13.7752 3.25045 14.0366 3.2686L14.1405 1.7722C13.8141 1.74955 13.4338 1.75 12.75 1.75V3.25ZM22.75 11.75C22.75 11.0662 22.7505 10.6859 22.7278 10.3595L21.2314 10.4634C21.2495 10.7248 21.25 11.041 21.25 11.75H22.75ZM14.0366 3.2686C17.8939 3.53634 20.9637 6.60614 21.2314 10.4634L22.7278 10.3595C22.4082 5.75571 18.7443 2.09176 14.1405 1.7722L14.0366 3.2686ZM11.25 1.75C10.5662 1.75 10.1859 1.74955 9.85949 1.7722L9.96336 3.2686C10.2248 3.25045 10.541 3.25 11.25 3.25V1.75ZM2.75 11.75C2.75 11.041 2.75045 10.7248 2.7686 10.4634L1.2722 10.3595C1.24955 10.6859 1.25 11.0662 1.25 11.75H2.75ZM9.85949 1.7722C5.25571 2.09176 1.59176 5.75571 1.2722 10.3595L2.7686 10.4634C3.03634 6.60614 6.10614 3.53634 9.96336 3.2686L9.85949 1.7722ZM4.23193 17.0585C3.39979 15.9157 2.8727 14.5363 2.7686 13.0366L1.2722 13.1405C1.39635 14.9291 2.02589 16.5772 3.01935 17.9415L4.23193 17.0585ZM2.9296 17.2207L1.32436 21.2207L2.71645 21.7793L4.32168 17.7793L2.9296 17.2207ZM9.96336 20.2314C8.84212 20.1536 7.78869 19.8394 6.85114 19.3385L6.1443 20.6615C7.26463 21.2601 8.5231 21.635 9.85949 21.7278L9.96336 20.2314ZM2.25865 22.2112L6.73598 20.7112L6.25947 19.2888L1.78215 20.7888L2.25865 22.2112Z"
                  fill="#141B34"
                />
                <path
                  d="M11.9955 12H12.0045M15.991 12H16M8 12H8.00897"
                  stroke="#141B34"
                  strokeWidth="2"
                  strokeLinecap="square"
                  strokeLinejoin="round"
                />
              </svg>

              <p>
                <Link to="https://api.whatsapp.com/send?phone=9246167123"  target="_blank">
                  Whatsapp
                </Link>
              </p>
            </span>
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6"
                  stroke="#141B34"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z"
                  stroke="#141B34"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
              <p>
                <Link to="mailto:info@creativeinflatables.in">SEND E-MAIL</Link>
              </p>
            </span>
          </div>
          <div className="disFlex">
            <div className="">Share Us:</div>
            <div className="icons">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="white"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.18182 10.3333C5.20406 10.3333 5 10.5252 5 11.4444V13.1111C5 14.0304 5.20406 14.2222 6.18182 14.2222H8.54545V20.8889C8.54545 21.8081 8.74951 22 9.72727 22H12.0909C13.0687 22 13.2727 21.8081 13.2727 20.8889V14.2222H15.9267C16.6683 14.2222 16.8594 14.0867 17.0631 13.4164L17.5696 11.7497C17.9185 10.6014 17.7035 10.3333 16.4332 10.3333H13.2727V7.55556C13.2727 6.94191 13.8018 6.44444 14.4545 6.44444H17.8182C18.7959 6.44444 19 6.25259 19 5.33333V3.11111C19 2.19185 18.7959 2 17.8182 2H14.4545C11.191 2 8.54545 4.48731 8.54545 7.55556V10.3333H6.18182Z"
                    stroke="#141B34"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>

              <a
                href="https://twitter.com/i/flow/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  target="_blank"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 18.5C3.76504 19.521 5.81428 20 8 20C14.4808 20 19.7617 14.8625 19.9922 8.43797L22 4.5L18.6458 5C17.9407 4.37764 17.0144 4 16 4C13.4276 4 11.5007 6.51734 12.1209 8.98003C8.56784 9.20927 5.34867 7.0213 3.48693 4.10523C2.25147 8.30185 3.39629 13.3561 6.5 16.4705C6.5 17.647 3.5 18.3488 2 18.5Z"
                    stroke="#141B34"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div className="ask">
          Maintenance by
            <Link to="https://www.askgraphix.in/" target="_blank">
              aSk Graphix
              <img src="./ask-face.svg"  alt="" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
export default FindUs;
